<script>
import * as d3 from 'd3'
import $ from 'jquery'
import setting from '@/setting.js'

export default {
    props: ['ball', 'mode', 'allBalls', 'baseBallIndex', 'savedBalls', 'currentAngle', 'slideBatx', 'slideBaty', 'slideBatz', 'slidePitx', 'slidePity', 'slidePitz', 'currentBatterPointSet', 'batterPanelState', 'pitcherPanelState', 'savedStandardBall', 'base', 'compar', 'PTReviewStandardBall', 'threeListSortMode'],
    emits: ['change-ward', 'submit-pitcher-position', 'submit-pitcher-point', 'submit-batter-position', 'submit-batter-point', 'close-batter-panel', 'reset-ward', 'change-batter-point'],
    data() {
        return {
            setting,
            opened: true,
            slideParamsx1: 0,
            slideParamsy1: 0,
            slideParamsz1: 0,
            slideParamsx2: 0,
            slideParamsy2: 0,
            slideParamsz2: 0,
            defaultParamsx1: 0,
            defaultParamsy1: 0,
            defaultParamsz1: 0,
            defaultParamsx2: 0,
            defaultParamsy2: 0,
            defaultParamsz2: 0,
            currentParamsx: 0,
            currentParamsz: 0,
            currentParamsy: 0,
            currentParamsx2: 0,
            currentParamsy2: 0,
            boxParamsx: 0,
            boxParamsz: 0,
            inputParamsx: 0,
            inputParamsz: 0,
            inputParamsy: 0,
            inputParamsx2: 0,
            inputParamsy2: 0,
            beforeAfterFlg: false,
            leftRightFlg: false,
            leftRightPitcherFlg: false,
            inputDefaultParamsx: 0,
            inputDefaultParamsz: 0,
            inputDefaultParamsy: 0,
            inputDefaultParamsx2: 0,
            inputDefaultParamsy2: 0,
            defaultBeforeAfterFlg: false,
            defaultLeftRightFlg: false,
            defaultLeftRightPitcherFlg: false,
            batterInputState: 0,
            pitcherInputState: 0,
            batterInputDisabled: false,
            batterPositionIsValid: false,
            batterPointIsValid: false,
            pitcherPositionIsValid: false,
            pitcherPointIsValid: false,
            width: 48,
            height: 72,
            xMin: -159.76,
            xMax: -36.84,
            xMin2: 36.84,
            xMax2: 158.76,
            yMin: 1730.96,
            yMax: 1913.84
        }
    },
    computed: {
        xScale: function () {
            return d3.scaleLinear().domain([this.xMax, this.xMin]).range([this.width, 0])
        },
        xScale2: function () {
            return d3.scaleLinear().domain([this.xMax2, this.xMin2]).range([this.width, 0])
        },
        yScale: function () {
            return d3.scaleLinear().domain([this.yMin, this.yMax]).range([0, this.height])
        },
        comparativeStandardBall: function () {
            if (this.threeListSortMode === 2) {
                return this.PTReviewStandardBall
            } else {
                return this.savedStandardBall
            }
        }
        // gameDate: function () {
        //   let date = this.ball.data.pitchingdata.Date
        //   date = typeof date === 'undefined' ? '' : date.split('/')[2] + 'å¹´' + date.split('/')[0] + 'æœˆ' + date.split('/')[1] + 'æ—¥'
        //   return date
        // }
    },
    watch: {
        slideParamsy1: 'changeBatterPoint',
        currentAngle: 'changeSlideParams',
        beforeAfterFlg: 'batterPositionValid',
        leftRightFlg: 'batterPositionValid',
    },
    mounted() {
        this.changeSlideParams()
    },
    methods: {
        changeWard: function (ward) {
            if (ward === 'forward') {
                if (this.currentBatterPointSet.slideBatPositionZMin < this.slideBatz) {
                    this.currentParamsz -= 1
                }
            } else if (ward === 'backward') {
                if (this.currentBatterPointSet.slideBatPositionZMax > this.slideBatz) {
                    this.currentParamsz += 1
                }
            } else if (ward === 'leftward') {
                if (this.currentBatterPointSet.slideBatPositionXMin < this.slideBatx) {
                    this.currentParamsx -= 1
                }
            } else if (ward === 'rightward') {
                if (this.currentBatterPointSet.slideBatPositionXMax > this.slideBatx) {
                    this.currentParamsx += 1
                }
            }
            this.$emit('change-ward', ward)
        },
        changeBatterPoint: function () {
            this.currentParamsy = this.slideParamsy1
            this.$emit('change-batter-point', this.slideParamsy1)
        },
        changeSlideParams: function () {
            this.slideParamsx1 = this.slideBatx
            this.slideParamsy1 = this.slideBaty
            this.slideParamsz1 = this.slideBatz
            this.slideParamsx2 = this.slidePitx
            this.slideParamsy2 = this.slidePity
            this.slideParamsz2 = this.slidePitz
            this.defaultParamsx1 = this.slideBatx
            this.defaultParamsy1 = this.slideBaty
            this.defaultParamsz1 = this.slideBatz
            this.defaultParamsx2 = this.slidePitx
            this.defaultParamsy2 = this.slidePity
            this.defaultParamsz2 = this.slidePitz
        },
        resetSlideParams: function () {
            this.slideParamsx1 = this.defaultParamsx1
            this.slideParamsz1 = this.defaultParamsz1
            this.currentParamsx = 0
            this.currentParamsz = 0
            this.$emit('reset-ward', [this.slideParamsx1, this.slideParamsz1])
        },
        formatBatParamsz: function (num) {
            if (num < 0) {
                return '前 ' + Math.abs(num)
            } else if (num > 0) {
                return '後 ' + Math.abs(num)
            } else {
                return num
            }
        },
        formatBatParamsx: function (num) {
            if (num < 0) {
                return '左 ' + Math.abs(num)
            } else if (num > 0) {
                return '右 ' + Math.abs(num)
            } else {
                return num
            }
        },
        closeBatterPanel: function () {
            this.$emit('close-batter-panel')
        },
        toggleBeforeAfterFlg: function (bool) {
            this.beforeAfterFlg = bool
        },
        toggleLeftRightFlg: function (bool) {
            this.leftRightFlg = bool
        },
        changeBatterInputState: function (num) {
            if (num === 1) {
                this.beforeAfterFlg = this.currentParamsz > 0
                this.inputParamsz = Math.abs(this.currentParamsz)
                this.leftRightFlg = this.currentParamsx < 0
                this.inputParamsx = Math.abs(this.currentParamsx)
                this.inputDefaultParamsx = this.inputParamsx
                this.inputDefaultParamsz = this.inputParamsz
                this.defaultBeforeAfterFlg = this.beforeAfterFlg
                this.defaultLeftRightFlg = this.leftRightFlg
            } else if (num === 2) {
                this.inputParamsy = this.currentParamsy
                this.inputDefaultParamsy = this.inputParamsy
            }
            this.batterInputState = num
        },
        validBatterParamsz: function (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsz = 0
            } else if (val < 0) {
                this.inputParamsz = 0
            }
            this.batterPositionValid()
        },
        validBatterParamsx: function (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsx = 0
            } else if (val < 0) {
                this.inputParamsx = 0
            }
            this.batterPositionValid()
        },
        validBatterParamsy: function (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsy = 160
            }
            this.batterPointValid()
        },
        batterPositionValid: function () {
            let validCount = 0
            let valid = false
            if (this.beforeAfterFlg) {
                if (this.inputParamsz > 10) {
                    validCount++
                }
            } else if (!this.beforeAfterFlg) {
                if (this.inputParamsz > 100) {
                    validCount++
                }
            }
            if (this.currentAngle === 'batterLeft') {
                if (this.leftRightFlg) {
                    if (this.inputParamsx > 70) {
                        validCount++
                    }
                } else if (!this.leftRightFlg) {
                    if (this.inputParamsx > 10) {
                        validCount++
                    }
                }
            } else if (this.currentAngle === 'batterRight') {
                if (this.leftRightFlg) {
                    if (this.inputParamsx > 30) {
                        validCount++
                    }
                } else if (!this.leftRightFlg) {
                    if (this.inputParamsx > 40) {
                        validCount++
                    }
                }
            }
            if (validCount > 0) {
                valid = true
            }
            this.batterPositionIsValid = valid
        },
        batterPointValid: function () {
            let validCount = 0
            let valid = false
            if (this.inputParamsy > 200) {
                validCount++
            } else if (this.inputParamsy < 160) {
                validCount++
            }
            if (validCount > 0) {
                valid = true
            }
            this.batterPointIsValid = valid
        },
        pitcherPositionValid: function () {
            let validCount = 0
            let valid = false
            if (this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            } else if (!this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPositionIsValid = valid
        },
        pitcherPointValid: function () {
            let validCount = 0
            let valid = false
            if (this.inputParamsy2 > 200) {
                validCount++
            } else if (this.inputParamsy2 < 160) {
                validCount++
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPointIsValid = valid
        },
        submitBatterPosition: function () {
            let x = this.inputParamsx
            let z = this.inputParamsz
            x = this.leftRightFlg ? -1 * x : x
            z = this.beforeAfterFlg ? z : -1 * z
            this.$emit('submit-batter-position', this.defaultParamsx1 + x, this.defaultParamsz1 + z)
            this.currentParamsx = x
            this.currentParamsz = z
            this.changeBatterInputState(0)
        },
        submitBatterPoint: function () {
            let y = this.inputParamsy
            this.$emit('submit-batter-point', y)
            this.currentParamsy = y
            this.slideParamsy1 = y
            this.changeBatterInputState(0)
        },
        submitPitcherPosition: function () {
            let x = this.inputParamsx2
            x = this.leftRightPitcherFlg ? -1 * x : x
            this.$emit('submit-pitcher-position', this.defaultParamsx2 + x)
            this.currentParamsx2 = x
            this.slideParamsx2 = x
            this.changePitcherInputState(0)
        },
        submitPitcherPoint: function () {
            let y = this.inputParamsy2
            this.$emit('submit-pitcher-point', y)
            this.currentParamsy2 = y
            this.slideParamsy2 = y
            this.changePitcherInputState(0)
        },
        resetBatterPosition: function () {
            this.inputParamsx = this.inputDefaultParamsx
            this.inputParamsz = this.inputDefaultParamsz
            this.beforeAfterFlg = this.defaultBeforeAfterFlg
            this.leftRightFlg = this.defaultLeftRightFlg
        },
        resetBatterPoint: function () {
            this.inputParamsy = this.inputDefaultParamsy
        },
        blurAfter: function () {
            $('body').scrollTop(0)
        }
    }
}
</script>
